<template>
    <div class="list-group">
        <div class="container dcs-planpick">
            <div class="row">
                <!-- <div class="col-md-4">
                    <div
                        class="dcs-selector-bar"
                        v-bind:class="thisPlanChosen(1)"
                    />
                    <div
                        class="dcs-planchoice dcs-plan-1"
                        @click="do_choosePlan(1)"
                        v-bind:class="thisPlanChosen(1)"
                    >
                        <div class="list-group-item flex-column align-items-start">
                            <h2>Free</h2>
                            <div class="dcs-money-msg">
                                <div class="dcs-medium-money">$0</div>
                                <div>( No credit card required )</div>
                            </div>
                        </div>
                        <div class="dcs-planinfo">
                            <div class="dcs-planinfo-border">
                                <p class="mb-1">For design professionals who want to get started commitment free.</p>
                            </div>
                        </div>
                    </div>
                </div> -->

                <div class="dcs-planblock">
                    <!-- col-md-5  -->
                    <div class="dcs-selector-bar" v-bind:class="thisPlanChosen(2)" />
                    <div class="dcs-planchoice dcs-plan-2" @click="do_choosePlan(2)" v-bind:class="thisPlanChosen(2)">
                        <!-- <div class="dcs-bigger-badge-placement"><img src="../assets/Pricing3monFree.svg" /></div> -->
                        <div class="list-group-item flex-column align-items-start">
                            <h2>Solo</h2>
                            <div class="dcs-money-msg">
                                <div class="dcs-medium-money">$74</div>
                                <div>Per month.</div>
                                <div style="margin: 8px 0">OR</div>
                                <div class="dcs-money-extra-line">Save 10% with one annual payment</div>
                                <div class="dcs-money-extra-line">
                                    of
                                    <span style="font-size: x-large">$799</span>
                                </div>
                            </div>
                        </div>
                        <div class="dcs-planinfo">
                            <div class="dcs-planinfo-border">
                                <p class="mb-1 dcs-small-off">For Sole Practitioners who need to simplify their workflow and control their financials.</p>
                            </div>
                        </div>
                    </div>
                    <div class="pcUserCountMessage">1 User only</div>
                </div>

                <div class="dcs-planblock">
                    <!-- col-md-5  -->
                    <div class="dcs-selector-bar" v-bind:class="thisPlanChosen(3)" />
                    <div class="dcs-planchoice dcs-plan-3" @click="do_choosePlan(3)" v-bind:class="thisPlanChosen(3)">
                        <!-- <div class="dcs-bigger-badge-placement"><img src="../assets/Pricing3monFree.svg" /></div> -->
                        <div class="list-group-item flex-column align-items-start">
                            <h2 class="dcs-small-off">Professional</h2>
                            <h2 class="dcs-small-on">Pro</h2>
                            <div class="dcs-money-msg">
                                <div class="dcs-medium-money">$54</div>
                                <div>Per month, per user.</div>
                                <div style="margin: 8px 0">OR</div>
                                <div class="dcs-money-extra-line">Save 10% with one annual payment</div>
                                <div class="dcs-money-extra-line">
                                    of
                                    <span style="font-size: x-large">$583</span>
                                    per user
                                </div>
                            </div>
                        </div>
                        <div class="dcs-planinfo">
                            <div class="dcs-planinfo-border">
                                <p class="mb-1 dcs-small-off">For small and larger teams that need simultaneous access, more control, and customization of reports.</p>
                            </div>
                        </div>
                    </div>
                    <div class="pcUserCountMessage">2 User Minimum</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "planpick",
    methods: {
        do_choosePlan(val) {
            this.$store.dispatch("choosePlan", val);
        },
        thisPlanChosen(arg) {
            let result = [];
            if (arg === this.$store.state.signupFormData.planClass) {
                result.push("chosen");
            } else {
                result.push("unselected");
            }
            return result;
        }
    }
};
</script>

<style>
.dcs-planpick.container {
    width: 80%;
    max-width: 1200px;
}
.dcs-planpick.container .row {
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
}
.dcs-planblock {
    width: 40%;
    position: relative;
}
.dcs-planchoice {
    cursor: pointer;
    color: white;
    border-radius: 8px;
}
.dcs-planchoice.dcs-plan-1 {
    background-color: rgb(178, 202, 52);
}
.dcs-plan-1 .dcs-planinfo {
    background-color: rgb(122, 141, 26);
}
.dcs-planchoice.dcs-plan-2 {
    background-color: rgb(119, 47, 153);
}
.dcs-plan-2 .dcs-planinfo {
    background-color: rgb(80, 27, 103);
}
.dcs-planchoice.dcs-plan-3 {
    background-color: rgb(62, 21, 81);
}
.dcs-plan-3 .dcs-planinfo {
    background-color: rgb(88, 26, 116);
}
.dcs-planchoice h2 {
    margin: 0;
    font-size: xx-large;
    font-family: "PT Serif", serif;
}
.dcs-planchoice .list-group-item {
    background-color: transparent;
    box-shadow: 0 7px 10px rgba(0, 0, 0, 0.2);
    border: 0;
}
.dcs-planchoice.chosen {
    box-shadow: 0 6px 20px rgba(32, 171, 235, 0.514);
    /* border: 2px solid rgba(209, 203, 149, 0.849); */
}
.dcs-planchoice.unselected {
    opacity: 0.8;
}
.dcs-selector-bar {
    margin-bottom: 8px;
    border: 2px solid transparent;
}
.dcs-selector-bar.chosen {
    border: 2px solid blue;
}
.dcs-planchoice .list-group-item.active,
.dcs-planchoice .list-group-item.active:hover {
}
.dcs-planinfo-border .mb-1 {
}
.dcs-planinfo-border.active .mb-1 {
}
.dcs-planinfo {
    padding: 20px 6px;
    min-height: 80px;
}
.dcs-planinfo p {
    margin: 0;
}
.dcs-planinfo-border {
    max-width: 342px;
    display: inline-block;
}
.dcs-planinfo-border.active {
}
.dcs-money-msg {
    position: relative;
    height: 160px;
    font-size: small;
}
.dcs-money-prefix {
    position: absolute;
    margin-top: 35px;
    margin-left: 15%;
}
.dcs-medium-money {
    font-size: xxx-large;
    font-family: "Montserrat", sans-serif;
}
.dcs-money-asterisk {
    font-size: 20pt;
    position: relative;
    top: -16px;
}
.dcs-small-asterisk {
    font-size: 14pt;
    position: relative;
    top: 2px;
}
.dcs-money-extra-line {
    position: relative;
    top: -6px;
}
.dcs-badge-placement {
    position: absolute;
    right: -30px; /*left: 266px;*/
    top: 45px;
    z-index: 100;
    max-width: 90px;
}
.dcs-badge-placement img {
    position: relative;
    width: 100%;
}
.dcs-bigger-badge-placement {
    position: absolute;
    right: -40px; /*left: 266px;*/
    top: 25px;
    z-index: 100;
    max-width: 140px;
}
.dcs-bigger-badge-placement img {
    position: relative;
    width: 100%;
}

.dcs-small-off {
    display: inline;
}
.dcs-small-on {
    display: none;
}
DIV.pcUserCountMessage {
    /* background-color: white; */
    font-weight:bold;
    margin-top:3px;
    font-size: large;
}
@media (max-width: 700px) {
    .dcs-bigger-badge-placement {
        display: none;
    }
    .dcs-small-off {
        display: none;
    }
    .dcs-small-on {
        display: inline;
    }
    .dcs-planpick.container {
        width: 100%;
    }
}
@media (max-width: 1000px) {
    .dcs-bigger-badge-placement img {
        width: 60%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/PlanPick.vue